import React from 'react'
import Icon from '@ui/elements/Icon/Icon'
import Animated, {
  interpolate,
  SharedValue,
  useAnimatedStyle,
} from 'react-native-reanimated'
import IconWithLoading from '@ui/buttons/Button/IconWithLoading'

interface Props {
  animation: SharedValue<number>
  hidden?: SharedValue<number>
  loading?: boolean
  size?: number
  color?: string
  className?: string
}

export const ToggleIcon = ({
  loading,
  animation,
  hidden,
  size,
  color,
  className = 'h-12 w-12 items-center justify-center',
}: Props) => {
  const style = useAnimatedStyle(() => {
    return {
      opacity: hidden ? interpolate(hidden.value, [0, 1], [1, 0]) : 1,
      transform: [
        {
          rotate: `-${animation.value * 180}deg`,
        },
      ],
    }
  })

  return (
    <Animated.View style={style} className={className}>
      {loading !== undefined ? (
        <IconWithLoading
          loading={!!loading}
          iconProps={{ name: 'chevron-down', size, color }}
        />
      ) : (
        <Icon name="chevron-down" size={size} color={color} />
      )}
    </Animated.View>
  )
}
